<template>
    <el-container>
        <el-header>
            <div class="nav">
                <div class="nav-menu">
                    <img class="logo" src="@/assets/img/logo.png" alt="">
                    <div class="menu-item active">
                        <router-link to="/plugin/plugin">应用购买</router-link>
                        <div class="bottom"></div>
                    </div>
                    <div class="menu-item">
                        <router-link to="/dashboard">管理中心</router-link>
                        <div class="bottom"></div>
                    </div>
                    <div class="login-status">
                        <span>
                            <router-link v-if="user.mobile > 0" to="/dashboard/user/index" style="cursor: pointer">{{user.mobile}}</router-link>
                            <router-link to="/passport/login" v-else>登录</router-link>
                        </span>
                        <span style="margin: 0 15px;">|</span>
                        <span @click="logout" style="cursor: pointer">退出</span>
                    </div>
                </div>
            </div>
        </el-header>
        <el-main>
            <router-view></router-view>
        </el-main>
    </el-container>
</template>

<style scoped>
    .el-header{
        padding: 0;
    }

    .logo{
        margin-top: 18px;
        margin-right: 20px;
        float: left;
        height: 24px;
        width: 114px;
    }

    .nav{
        height: 60px;
        line-height: 60px;
        font-size: 16px;
        color: #fff;
        background-color: #252D3F;
        position: fixed;
        width: 100%;
        z-index: 99;
        top: 0;
    }

    .nav a{
        color: #fff;
    }

    .nav-menu{
        width: 1200px;
        margin: 0 auto;
    }

    .menu-item.active a{
        color: #2E9FFF;
    }

    .active .bottom{
        height: 4px;
        width: 20px;
        border-radius: 2px;
        background-color: #2E9FFF;
        margin: -4px auto 0;
    }

    .menu-item{
        float: left;
        margin-left: 80px;
    }

    .login-status{
        float: right;
    }
@media screen and (max-width:767px){
    .nav{
        width: auto;
        left: 0;
        right: 0;
    }
    .nav-menu{
        width: 100%;
    }
    .menu-item{
        margin-left: 1rem;
    }
    .login-status{
        margin-right: 0.5rem
    }
    .login-status span:nth-child(2){
        margin: 0 0.5rem!important
    }
    .logo,.menu-icon{
        display: none;
    }
    .el-main{
        padding: 0;
    }
}
</style>

<script>
// @ is an alias to /src

export default {
    data() {
        return {
            user: {mobile: null},
            loading: false
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        loadData() {
            this.loading = true
            this.$store.dispatch('getUser').then(e => {
                this.loading = false
                this.user = e
            })
        },
        logout() {
            this.$store.dispatch('userLogout')
            this.$router.go({
                path: '/passport/login'
            })
        }
    }
}
</script>
